import { useRef } from 'react';
import ProductMedia from './productMedia/ProductMedia';
import type { ProductMediaProps } from './productMedia/ProductMedia';

export function ProductDynamicMedia({
  productMediaUrls,
  setIsZoomActive: setZoomActive,
  activeMediaSlide: activeSlide,
  setActiveMediaSlide: setActiveSlide,
  isPaginationDynamic: paginationDynamic,
  isPDPGiftCardType,
  productKey,
  badgesV2,
  productName,
  subTypes,
}: ProductMediaProps) {
  const ref = useRef();

  return (
    <ProductMedia
      badgesV2={badgesV2}
      isPDPGiftCardType={isPDPGiftCardType}
      productMediaUrls={productMediaUrls}
      setIsZoomActive={setZoomActive}
      isPaginationDynamic={paginationDynamic}
      ref={ref}
      activeMediaSlide={activeSlide}
      setActiveMediaSlide={setActiveSlide}
      productKey={productKey}
      productName={productName}
      subTypes={subTypes}
    />
  );
}
